import { HttpClient } from '@opallabs/api'
import { loadJsonApiEntities } from '../loadJsonApiEntities'

const fetchIntegrations = () =>
  HttpClient().get('/integrations/v1/capabilities')
const getIntegrations = () => (dispatch) =>
  fetchIntegrations()
    .then((response) => dispatch(loadJsonApiEntities(response.data)))
    .catch((err) => {
      console.log(err)
      throw err
    })

export default getIntegrations
